export interface Destination {
  country: string
  flag: string
  dish: string
  note: string
}

export const destinations: Destination[] = [
  { country: 'Argentine', flag: '🇦🇷', dish: 'La Buenos Aires', note: 'Bœuf, olives, cumin' },
  { country: 'Cuba', flag: '🇨🇺', dish: 'La Havana', note: 'Porc mojo, moutarde' },
  { country: 'Louisiane', flag: '⚜️', dish: 'La Nouvelle-Orléans', note: 'Écrevisses, cajun' },
  { country: 'Hawaï', flag: '🌺', dish: 'La Honolulu', note: 'Teriyaki, ananas' },
  { country: 'Angleterre', flag: '🇬🇧', dish: 'La London', note: 'Poulet, cheddar' },
  { country: 'Maroc', flag: '🇲🇦', dish: 'La Marrakech', note: 'Pois chiches, épices' },
]

export interface StopPoint {
  day: string
  place: string
  city: string
  hours: string
}

export const tour: StopPoint[] = [
  { day: 'Mardi', place: 'Place du Marché', city: 'Centre-ville', hours: '11h30 – 14h00' },
  { day: 'Mercredi', place: 'Zone des Prés', city: 'Parc d’activités', hours: '11h30 – 14h00' },
  { day: 'Jeudi', place: 'Parvis de la Gare', city: 'Centre-ville', hours: '11h30 – 14h00' },
  { day: 'Vendredi', place: 'Place de l’Église', city: 'Village voisin', hours: '18h00 – 21h00' },
  { day: 'Samedi', place: 'Marché couvert', city: 'Centre-ville', hours: '10h00 – 14h00' },
]
